export interface AdjustmentTransactionDto {
  id: string
  referenceId: string
  type: {
    id: number
    name: string
  }
  state: {
    id: number
    name: string
  }
  walletTransactionCount: number
  tradingAccountTransactionCount: number
  tickmillCompany: {
    id: number
    name: string
  }
  client: {
    id: number
    name: string
  }
  clientCount: number
  wallet: {
    id: number
    name: string
  }
  walletCount: number
  tradingAccount: {
    id: number
    name: string
  }
  tradingAccountCount: number
  currency: {
    id: number
    name: string
  }
  amount: number
  createdDate: string
  updatedDate: string
}

export enum AdjustmentTransactionKey {
  type = 'type.name',
  reference = 'referenceId',
  state = 'state.name',
  client = 'client.name',
  wallet = 'wallet.name',
  tradingAccount = 'tradingAccount.name',
  amount = 'amount',
  currency = 'currency.id',
  tickmillCompany = 'tickmillCompany.name',
  createdDate = 'createdDate',
  updatedDate = 'updatedDate',
  tradingAccountCount = 'tradingAccountCount',
  platformType = 'tradingAccountPlatformType.name',
}

export enum AdjustmentTransactionFilterKey {
  type = 'TransactionTypeId',
  reference = 'Reference',
  state = 'TransactionStateId',
  client = 'Client',
  country = 'Client.CountryId',
  wallet = 'WalletId',
  walletType = 'WalletTypeId',
  platform = 'Platform',
  tickmillCompany = 'TickmillCompany',
  tradingAccount = 'TaId',
  createdDate = 'DateCreated',
  updatedDate = 'DateUpdated',
  createdDateTime = 'DateTimeCreated',
  updatedDateTime = 'DateTimeUpdated',
  assignee = 'Assignee',
}
